import Objdict from "objdict"
import Unit from "@fae/source/models/Unit.js"

function isEqual(x, y) {
    if(!x && !y) return true
    if(x && y && typeof x === "object" && typeof y === "object") {
        return Object.keys(x).concat(Object.keys(y)).every(key => isEqual(x[key], y[key]))
    }
    return (x === y)
}

export default class Delta {
    static copyDeltastageSum(oldSum) {
        const newSum = {}
        oldSum = oldSum || {}
        Object.keys(oldSum).forEach((key) => {
            if(key == "dialogue") {
                newSum.dialogue = Object.assign({}, oldSum.dialogue)
                return
            }
            if(key == "flags") {
                newSum.flags = Object.assign({}, oldSum.flags)
                return
            }
            if(key == "player") {
                newSum.player = {}
                newSum.player.score = oldSum.player.score
                newSum.player.affiliation = oldSum.player.affiliation
                newSum.player.inventory = Object.assign({}, oldSum.player.inventory)
                return
            }
            if(key == "units") {
                newSum.units = {}
                Object.keys(oldSum.units).forEach((unitKey) => {
                    if(oldSum.units[unitKey] == undefined) return // andrew added
                    newSum.units[unitKey] = {}
                    Object.keys(oldSum.units[unitKey]).forEach((key) => {
                        if(key == "inventory") {
                            newSum.units[unitKey][key] = {}
                            Object.keys(oldSum.units[unitKey][key]).forEach((subkey) => {
                                newSum.units[unitKey][key][subkey] = Object.assign({}, oldSum.units[unitKey][key][subkey])
                            })
                        } else if(key == "energy") {
                            newSum.units[unitKey][key] = {}
                            Object.keys(oldSum.units[unitKey][key]).forEach((subkey) => {
                                newSum.units[unitKey][key][subkey] = oldSum.units[unitKey][key][subkey]
                            })
                        } else if(key == "effects" || key == "position") {
                            newSum.units[unitKey][key] = Object.assign({}, oldSum.units[unitKey][key])
                        } else {
                            newSum.units[unitKey][key] = oldSum.units[unitKey][key]
                        }
                    })
                })
                return
            }
            newSum[key] = oldSum[key]
        })
        return newSum
    }
    static addDeltastages(runningSum, newDeltas) {
        if(newDeltas instanceof Array == false) {
            newDeltas = [newDeltas]
        }
        newDeltas.forEach((newDelta) => {
            if(newDelta == undefined) return
            if(newDelta instanceof Array == true) {
                newDelta.forEach((subnewDelta) => {
                    Delta.addDeltastages(runningSum, subnewDelta)
                })
                return
            }
            Object.keys(newDelta).forEach((key) => {
                if(newDelta[key] instanceof Function) return
                if(key == "mark" || key == "motion" || key == "timing" || key == "func" || key == "audiomix" || key == "audio" || key == "intent") return
                if(key == "deltastages") {
                    newDelta.deltastages.forEach((subnewDelta) => {
                        Delta.addDeltastages(runningSum, subnewDelta)
                    })
                    return
                }
                if(key == "position" || key == "key") {
                    // console.log("trying to enter unit property as delta", newDeltas, newDelta)
                    return
                }
                if(key == "flag" || key == "flags") {
                    let flags = newDelta.flags || {}
                    if(newDelta.flag != undefined) {
                        flags[newDelta.flag.key] = newDelta.flag.value
                    }
                    runningSum.flags = Objdict.merge(runningSum.flags || {}, flags)
                    return
                }
                if(key == "player") {
                    runningSum.player = newDelta.player
                    runningSum.player.inventory = Objdict.merge(runningSum.player.inventory || {}, newDelta.player.inventory)
                    return
                }
                // if it's not one of the above merges, nor a deltaunit
                // then it's an absolute set and we're safe to nuke the old values
                if(key != "units" && key != "unit" && key != "stage") {
                    runningSum[key] = newDelta[key]
                    return
                }

                runningSum.units = runningSum.units || {}
                let newDeltaunits
                if(key == "units") {
                    newDeltaunits = newDelta.units
                } else if(key == "stage") {
                    newDeltaunits = newDelta.stage.units
                } else if(key == "unit") {
                    newDeltaunits = {}
                    newDeltaunits[newDelta.unit.key] = newDelta.unit
                }

                Objdict.forEach(newDeltaunits, (deltaunit, unitKey) => {
                    if(deltaunit == undefined) {
                        runningSum.units[unitKey] = undefined
                        return
                    }
                    runningSum.units[unitKey] = runningSum.units[unitKey] || {}
                    Object.keys(deltaunit).forEach((unitPropertyKey) => {
                        if(unitPropertyKey == "energy") {
                            runningSum.units[unitKey].energy = Objdict.merge(runningSum.units[unitKey].energy || {}, deltaunit.energy)
                            return
                        }
                        if(unitPropertyKey == "inventory") {
                            runningSum.units[unitKey].inventory = runningSum.units[unitKey].inventory || {}
                            runningSum.units[unitKey].inventory.count = runningSum.units[unitKey].inventory.count + deltaunit.inventory.count
                            runningSum.units[unitKey].inventory.items = Objdict.merge(runningSum.units[unitKey].inventory.items || {}, deltaunit.inventory.items)
                            return
                        }
                        if(unitPropertyKey == "effects") {
                            runningSum.units[unitKey].effects = Objdict.merge(runningSum.units[unitKey].effects || {}, deltaunit.effects)
                            return
                        }
                        if(unitPropertyKey == "position") {
                            runningSum.units[unitKey].position = runningSum.units[unitKey].position || {}
                            runningSum.units[unitKey].position.mode = "absolute"
                            if(deltaunit.position.x !== undefined) {
                                runningSum.units[unitKey].position.x = deltaunit.position.x
                            }
                            if(deltaunit.position.y !== undefined) {
                                runningSum.units[unitKey].position.y = deltaunit.position.y
                            }
                            if(deltaunit.position.z !== undefined) {
                                runningSum.units[unitKey].position.z = deltaunit.position.z
                            }
                            //console.log("summed position", unitKey, runningSum.units[unitKey].position)
                            return
                        }
                        runningSum.units[unitKey][unitPropertyKey] = deltaunit[unitPropertyKey]
                    })
                })
            })
        })
    }
    static diffDeltastageSums(a, b) {
        const diff = {}
        const keys = Object.keys(a).concat(Object.keys(b))
        keys.forEach((key) => {
            if(key == "intent" || key == "type" || key == "text" || key == "dialogue" || key == "events") return
            if(key == "flags") {
                diff[key] = {}
                const aProp = a[key] || {}
                const bProp = b[key] || {}
                const propKeys = Object.keys(aProp).concat(Object.keys(bProp))
                propKeys.forEach((subkey) => {
                    if(aProp[subkey] == undefined || bProp[subkey] == undefined) {
                        if(aProp[subkey] == bProp[subkey]) return
                        diff[key][subkey] = {"a": aProp[subkey], "b": bProp[subkey]}
                        return
                    }
                    if(aProp[subkey] != bProp[subkey]) diff[key][subkey] = {"a": aProp[subkey], "b": bProp[subkey]}
                })
                if(Object.keys(diff[key]).length == 0) delete diff[key]
            } else if(key == "player") {
                diff.player = {}
                const aPlayer = a.player || {}
                const bPlayer = b.player || {}
                if(aPlayer.score != bPlayer.score) diff.player.score = {"a": aPlayer.score, "b": bPlayer.score}
                if(aPlayer.affiliation != bPlayer.affiliation) diff.player.affiliation = {"a": aPlayer.affiliation, "b": bPlayer.affiliation}
                diff.player.inventory = {}
                const inventoryKeys = Object.keys(aPlayer.inventory).concat(Object.keys(bPlayer.inventory))
                inventoryKeys.forEach((subkey) => {
                    if(aPlayer.inventory[subkey] != bPlayer.inventory[subkey]) diff.player.inventory[subkey] = {"a": aPlayer.inventory[subkey], "b": bPlayer.inventory[subkey]}
                })
                if(Object.keys(diff.player.inventory).length == 0) delete diff.player.inventory
                if(Object.keys(diff.player).length == 0) delete diff.player
            } else if(key == "units") {
                diff[key] = {}
                const unitsKeys = Object.keys(a[key] || {}).concat(Object.keys(b[key] || {}))
                unitsKeys.forEach((unitKey) => {
                    diff.units[unitKey] = {}
                    const diffUnit = diff.units[unitKey]
                    const aUnit = a.units[unitKey]
                    const bUnit = b.units[unitKey]
                    if(aUnit == undefined || bUnit == undefined) {
                        diff.units[unitKey] = {"a": aUnit, "b": bUnit}
                        return
                    }
                    const unitKeys = Object.keys(aUnit).concat(Object.keys(bUnit))
                    unitKeys.forEach((propKey) => {
                        if(aUnit[propKey] == undefined || bUnit[propKey] == undefined) {
                            diffUnit[propKey] = {"a": aUnit[propKey], "b": bUnit[propKey]}
                            return
                        }
                        if(isEqual(aUnit[propKey], bUnit[propKey]) == false) diffUnit[propKey] = {"a": aUnit[propKey], "b": bUnit[propKey]}
                    })
                    if(Object.keys(diffUnit).length == 0) delete diff.units[unitKey]
                })
                if(Object.keys(diff[key]).length == 0) delete diff[key]
            } else {
                if(isEqual(a[key], b[key]) == false) diff[key] = {"a": a[key], "b": b[key]}
            }
        })

        return diff
    }
    static compareDeltastageSums(a, b) {
        return Object.values(Delta.diffDeltastageSums(a, b)).length > 0
    }




    // edits in place, also returns the same reference.
    // most properties are naively merged in, but some
    // are carefully deeply merged, at least for one layer of merge.
    static editUnit(unit, deltaunit) {
        const SPECIAL_MERGE = {
            "position": function(unit, deltaunit) {
                if(deltaunit.position.x !== undefined) {
                    unit.position.x = deltaunit.position.x
                }
                if(deltaunit.position.y !== undefined) {
                    unit.position.y = deltaunit.position.y
                }
                if(deltaunit.position.z !== undefined) {
                    unit.position.z = deltaunit.position.z
                }
                return unit.position
            },
            "energy": function(unit, deltaunit) {
                unit.energy = {
                    ...unit.energy,
                    ...deltaunit.energy,
                }
                return unit.energy
            },
            "effects": function(unit, deltaunit) {
                Objdict.forEach(deltaunit.effects, (effect, effectKey) => {
                    effectKey = effect?.key ?? effectKey
                    if(effect == undefined) {
                        delete unit.effects[effectKey]
                    } else if(unit.effects[effectKey] == undefined) {
                        unit.effects[effectKey] = effect
                    } else {
                        unit.effects[effectKey] = Objdict.merge(unit.effects[effectKey], effect)
                    }
                })
                return unit.effects
            },
            "flags": function(unit, deltaunit) {
                unit.flags = {
                    ...unit.flags,
                    ...deltaunit.flags,
                }
                return unit.flags
            },
            // // These are copied over from Unit.copy - I suspect
            // // that these properties are handled the same both
            // // here and there!! But not all of them are here?
            // "position": unit.position && {
            //     ...unit.position
            // },
            // "energy": unit.energy && {
            //     ...unit.energy
            // },
            // "inventory": unit.inventory && {
            //     "items": {
            //         ...unit.inventory.items
            //     }
            // },
            // "effects": unit.effects && {
            //     ...Objdict.map(unit.effects, (effect) => {
            //         return {
            //             ...effect
            //         }
            //     })
            // }
            // "passives": unit.passives && [
            //     ...unit.passives,
            // ],
            // "items": unit.items && {
            //     ...unit.items
            // },
            // "ai": unit.ai && {
            //     "state": unit.ai.state,
            //     "behaviors": unit.ai.behaviors
            // },
        }

        Object.keys(deltaunit).forEach((key) => {
            if(deltaunit[key] === undefined) {
                // Ignore undefined properties.
            } else if(deltaunit[key] === null) {
                delete unit[key]
            } else if(SPECIAL_MERGE[key] instanceof Function) {
                SPECIAL_MERGE[key](unit, deltaunit)
            } else {
                unit[key] = deltaunit[key]
            }
        })

        return unit
    }


    static editStage(stage, deltastages) {
        if(deltastages instanceof Array == false) {
            deltastages = [deltastages]
        }
        deltastages.forEach((deltastage) => {
            if(deltastage == undefined) return

            // We support some syntactic sugar shortcuts
            // so you don't have to write out deltastage.units
            // or deltastage.flags each and every time.
            if(deltastage.unit != undefined
            && deltastage.units == undefined) {
                deltastage.units = {
                    [deltastage.unit.key]: deltastage.unit
                }
            }
            if(deltastage.flag != undefined
            && deltastage.flags == undefined) {
                deltastage.flags = {
                    [deltastage.flag.key]: deltastage.flag.value
                }
            }

            const SPECIAL_MERGE = {
                "units": function(stage, deltastage) {
                    Object.keys(deltastage.units).forEach((key) => {
                        const deltaunit = deltastage.units[key]
                        if(deltaunit === undefined) {
                            // Ignore undefined properties.
                        } else if(deltaunit === null) {
                            delete stage.units[key]
                        } else {
                            if(deltaunit.key == undefined) {
                                deltaunit.key = key
                            }
                            // TODO: This is the one rare case of actual logic here in the merge.
                            // If it wasn't for this, just about all of this could be collapsed into
                            // a giant conditional merge (somethings being merged more deeply than
                            // others.) But not until this is centralized elsewhere. Either make it
                            // so there are no "default" unit properties that need initializing, or
                            // make the scripts that make new units have to merge it themselves.
                            if(stage.units[deltaunit.key] === undefined) {
                                stage.units[deltaunit.key] = Unit.instantiate({"unit": deltaunit, "random": stage.random})
                            }
                            stage.units[deltaunit.key] = Delta.editUnit(stage.units[deltaunit.key], deltaunit)
                        }
                    })
                    return stage.units
                },
                "player": function(stage, deltastage) {
                    stage.player = Delta.editPlayer(stage.player, deltastage.player)
                    return stage.player
                },
                "turn": function(stage, deltastage) {
                    if(deltastage.turn.number != undefined) {
                        stage.turn.number = deltastage.turn.number
                    }
                    if(deltastage.turn.phase != undefined) {
                        stage.turn.phase = deltastage.turn.phase
                    }
                    if(deltastage.turn.affiliation != undefined) {
                        stage.turn.affiliation = deltastage.turn.affiliation
                    }
                    return stage.turn
                },
                "flags": function(stage, deltastage) {
                    stage.flags = Objdict.merge(stage.flags, deltastage.flags)
                    return stage.flags
                },
                "dialogue": function(stage, deltastage) {
                    // TODO: Make this more permissive to new dialogue properties!!!
                    stage.dialogue = stage.dialogue || {}
                    stage.dialogue.text = deltastage.dialogue.text
                    stage.dialogue.index = deltastage.dialogue.index
                    stage.dialogue.type = deltastage.dialogue.type
                    stage.dialogue.data = deltastage.dialogue.data
                    stage.dialogue.portraitScene = deltastage.dialogue.portraitScene
                    // stage.dialogue.speakingCharacter = deltastage.dialogue.speakingCharacter
                    // stage.dialogue.tags = deltastage.dialogue.tags
                    // stage.dialogue.characters = stage.dialogue.characters || {}
                    // stage.dialogue.characters[stage.dialogue.speakingCharacter] = stage.dialogue.characters[stage.dialogue.speakingCharacter] || {}
                    // stage.dialogue.characters[stage.dialogue.speakingCharacter].tags = stage.dialogue.characters[stage.dialogue.speakingCharacter].tags || {}
                    // Objdict.forEach(deltastage.dialogue.tags, (value, key) => {
                    //     if(key == "_") return
                    //     stage.dialogue.characters[stage.dialogue.speakingCharacter].tags[key] = value
                    // })
                    return stage.dialogue
                },
                "encounters": function(stage, deltastage) {
                    stage.encounters = deltastage.encounters
                    // TODO: Deprecate stage.world.encounters, we only need stage.encounters
                    if(stage.world != undefined) {
                        stage.world.encounters = deltastage.encounters
                    }
                    return stage.encounters
                },
                "spots": function(stage, deltastage) {
                    stage.spots = deltastage.spots
                    // TODO: Deprecate stage.world.spots, we only need stage.spots
                    if(stage.world != undefined) {
                        stage.world.spots = deltastage.spots
                    }
                    return stage.spots
                },
                "events": function(stage, deltastage) {
                    if(deltastage.events == null) {
                        stage.events = []
                        return stage.events
                    }
                    stage.events = stage.events || []
                    stage.events = [
                        ...stage.events,
                        ...deltastage.events
                    ]
                    return stage.events
                },
            }

            Object.keys(deltastage).forEach((key) => {
                if(deltastage[key] === undefined) {
                    // Ignore undefined properties.
                } else if(deltastage[key] === null) {
                    delete stage[key]
                } else if(SPECIAL_MERGE[key] instanceof Function) {
                    SPECIAL_MERGE[key](stage, deltastage)
                } else {
                    stage[key] = deltastage[key]
                }
            })
        })
        return stage
    }
    static editPlayer(player, deltaplayer) {
        const SPECIAL_MERGE = {
            "inventory": function(player, deltaplayer) {
                if(deltaplayer.inventory.kindling != undefined) {
                    player.inventory.kindling = deltaplayer.inventory.kindling
                }
                if(deltaplayer.inventory.items != undefined) {
                    Objdict.forEach(deltaplayer.inventory.items, (item, key) => {
                        if(item === undefined) {
                            // Ignore undefined properties.
                        } else if(item === null) {
                            delete player.inventory.items[key]
                        } else {
                            player.inventory.items[key] = item
                        }
                    })
                }
                return player.inventory
            }
        }

        Object.keys(deltaplayer).forEach((key) => {
            if(deltaplayer[key] === undefined) {
                // Ignore undefined properties.
            } else if(deltaplayer[key] === null) {
                delete player[key]
            } else if(SPECIAL_MERGE[key] instanceof Function) {
                SPECIAL_MERGE[key](player, deltaplayer)
            } else {
                player[key] = deltaplayer[key]
            }
        })
        return player
    }
    // TODO: make this a universal centralized pattern all the way down??
    static merge(a, b) {
        const SPECIAL_MERGE = {}
        Object.keys(b).forEach((key) => {
            if(b[key] === undefined) {
                // Ignore undefined properties.
            } else if(b[key] === null) {
                delete a[key]
            } else if(SPECIAL_MERGE[key] instanceof Function) {
                SPECIAL_MERGE[key](a, b)
            } else {
                a[key] = b[key]
            }
        })
    }
}


// // TODO: also shadow the tiles
// action.shadowtiles = clonedeep(action.shadowtiles)
// if(action.results != undefined) {
//     Object.keys(action.results).forEach((key) => {
//         const result = action.results[key]
//         if(key.substring(0, 5) === "tile:") {
//             const tile = action.shadowtiles.find((tile) => tile.key == key.substring(5))
//             if(tile != undefined) {
//                 return
//             }
//             tile.isBurning = result.isBurning
//             return
//         }
//         // else is unit!!
//     })
// }

// // USED TO BE IN THE ATTACK BEAT PERFORMANCE
// if(key.substring(0, 5) == "tile:") {
//     let position = key.substring(5)
//     let tile = model.game.chapter.stage.map.tiles[position]
//     if(tile == undefined) {
//         return
//     }
//     tile.isBurning = result.isBurning || tile.isBurning
//     return
// }
// if(result.effects) {
//     unit.applyEffects(result.effects)
// }
// if(result.hasPerformedAction != undefined) {
//     if(result.hasPerformedAction == false) {
//         unit.hasPerformedMove = false
//         unit.hasPerformedAttack = false
//         unit.hasPerformedAction = false
//     }
// }

// if(key == "performer") {
//     unit = stage.findUnitByKey(action.performer.key)
// } else if(key == "target") {
//     unit = stage.findUnitByKey(action.target.key)
// }
